module.exports = __webpack_public_path__ + "img/broadcast-work-icon10.01206b34.png";